export const isFetching = (state) => state.api.isFetching
export const getProfileData = (state) =>
  state.user.profile && state.user.profile.collection
export const getProfileMedia = (state) => state.user.media

export const getUserApps = (state) => state.user.companies
